export const TRANSFER_STATUSES = {
  CANCELED: 'CANCELED',
  PROCESS: 'PROCESS',
  REQUESTED: 'REQUESTED',
  CONCLUDED: 'CONCLUDED',
  REJECTED: 'REJECTED',
};
